
import AbstractInstaller from "../../core/application/AbstractInstaller";
import ConversationReflectionEndedEvent from "../conversation-reflection/event/ConversationReflectionEndedEvent";
import ConversationEndedEvent from "../conversation/event/ConversationEndedEvent";
import PlatformUserService from "./controller/PlatformUserService";
import PlatformUserTrackingService from "./controller/PlatformUserTrackingService";
import TrackPlatformConversationEnded from "./controller/TrackPlatformConversationEnded";
import TrackPlatformReflectionEnded from "./controller/TrackPlatformReflectionEnded";
import PlatformUserModel from "./model/PlatformUserModel";
import AuthenticatePlatformTask from "./task/AuthenticatePlatformTask";

export default class PlatformInstaller extends AbstractInstaller {
    /**
     * @constructor
     * @param {infuse.Injector} injector 
     * @param {soma.Commands} commands 
     * @param {MediatorMapping} mediatorMap 
     */
    constructor(injector, commands, mediatorMap) {
        super(injector, commands, mediatorMap);

        commands.add(ConversationEndedEvent.TYPE, TrackPlatformConversationEnded);
        commands.add(ConversationReflectionEndedEvent.PERFORM, TrackPlatformReflectionEnded);

        injector.mapClass("platformUserService", PlatformUserService, true);
        injector.mapClass("platformUserTrackingService", PlatformUserTrackingService, true);
        injector.mapClass("platformUserModel", PlatformUserModel, true);

        this._addStartupTask(AuthenticatePlatformTask, "authenticatePlatformTask", 1);
    }
}